import { render, staticRenderFns } from "./SingleProjectComponent.vue?vue&type=template&id=5aefa872&scoped=true&"
import script from "./SingleProjectComponent.vue?vue&type=script&lang=js&"
export * from "./SingleProjectComponent.vue?vue&type=script&lang=js&"
import style0 from "./SingleProjectComponent.vue?vue&type=style&index=0&id=5aefa872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aefa872",
  null
  
)

export default component.exports